var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShareTwitter = function SvgIconShareTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M8.495 10.448 4 3h3.56l2.776 4.603L13.3 3.021h1.961l-3.977 6.155L16 17h-3.55l-3.005-4.978-3.208 4.964H4.266l4.23-6.538Zm4.472 5.172L6.183 4.38h.86l6.775 11.24h-.85Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconShareTwitter;